var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M36.7 29.22 29.48 14.7a2 2 0 0 1 .31-2.29l1.9-2.15a3.06 3.06 0 0 0 .31-3.8 3.61 3.61 0 0 0-5-.79l-.14.1a4.1 4.1 0 0 1-4.79 0 3.74 3.74 0 0 0-4.15-.22 3 3 0 0 0-.74 4.63l2 2.24a2 2 0 0 1 .31 2.29l-7.25 14.51a11 11 0 0 0-.67 8.52 7.3 7.3 0 0 0 5.05 4.95 8.1 8.1 0 0 0 2.2.26h11.31a8.1 8.1 0 0 0 2.2-.26 7.34 7.34 0 0 0 5.05-4.95 11 11 0 0 0-.68-8.52ZM15.22 15.95h19.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "M28 25h-4.15a1.79 1.79 0 0 0-1.79 1.79v1.63a1.35 1.35 0 0 0 1.34 1.35h2.68A1.93 1.93 0 0 1 28 31.72v.87a2.21 2.21 0 0 1-2.21 2.2h-3.73M25.01 21.64v2.87M25.01 35.44v2.87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 4h28.95v39.95H10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.b7125f3ac34ebf8d5ea7429066f763a9.svg";
export { ForwardRef as ReactComponent };